import {getRequest, postRequest} from "../fetchWrapper";

/**
 * Récupération de la liste des utilisateurs.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getUserList = (token, pageNumber, itemsPerPage, keywords) => {
    const url = `/api-v1/admin/user/${pageNumber}/${itemsPerPage}/${keywords}/list`
    return getRequest(url, token);
}

/**
 * Post de l'action sur le changement de statut d'un utilisateur.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const setUserEnabled = (token, userId) => {
    const url = `/api-v1/admin/user/enable`
    return postRequest(url, userId, token);
}

/**
 * Récupération de la liste des utilisateurs pour une agence.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyUserList = (token, id) => {
    const url = `/api-v1/user/${id}/list`
    return getRequest(url, token);
}

/**
 * Récupération d'un utilisateur côté admin.
 *
 * @param int $id Id de l'utilisateur.
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAdminUserInfos = (token, id) => {
    const url = `/api-v1/admin/user/${id}/infos`
    return getRequest(url, token);
}

/**
 * Modification d'un utilisateur côté admin.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateUserInfos = (token, body) => {
    const url = `/api-v1/admin/user/infos`
    return postRequest(url, body, token);
}

/**
 * Suppression d'un utilisateur côté admin.
 *
 * @param int $id Id de l'utilisateur.
 * @param string $token Jeton d'authentification.
 */
export const deleteUser = (token, body) => {
    const url = `/api-v1/admin/user/delete`
    return postRequest(url, body, token);
}

/**
 * Usurpation d'un utilisateur côté admin.
 *
 * @param string $token Jeton d'authentification.
 * @param int $userId Id de l'utilisateur.
 *
 * @returns Response | null Réponse de la requête à l'API.
 */
export const switchUser = (token, userName) => {
    const url = `/api-v1/admin/user/impersonate?_switch_user=${userName}`
    return getRequest(url, token);
}